// extracted by mini-css-extract-plugin
module.exports = {"otherProject":"OtherProject_otherProject__1Wh87","codeLink":"OtherProject_codeLink__3HDcY"};